import type { ChatConnection } from '../types';
import { useSendbirdInitialization } from './useSendbirdInitialization';
import { useSendbirdMessaging } from './useSendbirdMessaging';
import { useSendbirdConnectionControls } from './useSendbirdConnectionControls';

export const useChatConnection = (): ChatConnection => {
    useSendbirdInitialization();
    const { sendMessage, markMessagesAsRead } = useSendbirdMessaging();
    const { disconnect, reconnect, resetChatErrors } = useSendbirdConnectionControls();

    return {
        markMessagesAsRead,
        sendMessage,
        disconnect,
        reconnect,
        resetChatErrors,
    };
};
